import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usersActions from '../../redux/actions/usersActions';

import InputErrors from '../common/InputErrors';
import KeyError from '../common/KeyError';

class JoinPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      department: '',
      position: '',
      password1: '',
      password2: '',
      passwordsMatchError: false,
      noPassword1Error: false,
      noPassword2Error: false,
      serverErrors: [],
      onloadErrors: [],
      keyValidated: false,
    };
  }

  componentDidMount() {
    if (this.props.location.search.length) {
      this.props.usersActions.getJoinData(
        this.props.location.search.substring(1), // remove leading '?'
        this.onOnloadSuccess,
        this.onOnloadFail
      );
    }
  }

  onOnloadSuccess = (data) => {
    // Allow the page to continue loading
    this.setState({
      ...data,
      onloadErrors: [],
      keyValidated: true,
    });
  }

  onOnloadFail = (error) => {
    // Display the onload error state
    this.setState({
      onloadErrors: ['There was a server error with your key.'],
      keyValidated: true,
    });
  }

  login = (e) => {
    e.preventDefault();
    this.resetErrors();
    if (!this.state.password1) {
      this.setState({noPassword1Error: true});
    } else if (!this.state.password2) {
      this.setState({noPassword2Error: true});
    } else if (this.state.password1 !== this.state.password2) {
      this.setState({passwordsMatchError: true});
    } else {
      this.props.usersActions.join({
        userKey: this.props.location.search.substring(1), // remove leading '?'
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        department: this.state.department,
        position: this.state.position,
        password: this.state.password1,
      }, this.onFail);
    }
  }

  resetErrors = () => {
    this.setState({
      passwordsMatchError: false,
      noPassword1Error: false,
      noPassword2Error: false,
      serverErrors: [],
    });
  }

  onFail = (error) => {
    // TO DO: Show errors in form
    // Password validation
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was an error with your registration.'],
    });
  }

  handleInputChange = ({ target }) => {
    const { name } = target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState({ [name]: value });
  }

  render() {
    const {
      serverErrors,
      noPassword1Error,
      noPassword2Error,
      passwordsMatchError,
      keyValidated,
      onloadErrors,
      institution,
      firstName,
      lastName,
      email,
      location,
      department,
      position,
      password1,
      password2,
    } = this.state;

    // Aggregate error messages
    let errors = serverErrors;
    if (noPassword1Error || noPassword2Error) errors = [...errors, 'Please fill in both password fields.'];
    if (passwordsMatchError) errors = [...errors, 'Your passwords must match.'];

    // Wait for database response
    if (!keyValidated) {
      return null; // TO DO: add loading state
    }
    // Handle a bad key
    if (onloadErrors.length) {
      return <KeyError />;
    }
    // Jump out if there's no user key in the query params
    if (!this.props.location.search.length) return <Redirect to="/" />;
    // TO DO: Probably add in a loading state while waiting for the database to respond
    return this.props.loggedIn ? (
      // After login, redirect to the dashboard
      <Redirect to="/" />
    ) : (
      <Fragment>
        <Helmet>
          <title>Welcome</title>
        </Helmet>
        <div className="fullscreen-form">
          <div className="row fullscreen-form__content">
            <h1 className="fullscreen-form__heading">
              You’ve Been Invited to Join {institution}
            </h1>
            <div className="fullscreen-form__subheading">
              Enter your personal information below to begin using the <span style={{ whiteSpace: 'noWrap' }}>self-assessment</span>&nbsp;tool.
            </div>
            <form className="form fullscreen-form__form fullscreen-form__form--extra-margin">
              {errors.length !== 0 && <InputErrors errors={errors} />}
              <label htmlFor="firstName">
                First Name
              </label>
              <input
                name="firstName"
                id="firstName"
                value={firstName}
                onChange={this.handleInputChange}
                type="text"
              />
              <label htmlFor="lastName">
                Last Name
              </label>
              <input
                name="lastName"
                id="lastName"
                value={lastName}
                onChange={this.handleInputChange}
                type="text"
              />
              <label htmlFor="email">
                Email
              </label>
              <input
                name="email"
                id="email"
                value={email}
                type="email"
                disabled
              />
              <label htmlFor="institution">
                Institution
              </label>
              <input
                name="institution"
                id="institution"
                value={institution}
                type="text"
                disabled
              />
              <label htmlFor="location">
                Location
              </label>
              <input
                name="location"
                id="location"
                value={location || ''}
                type="text"
                disabled
              />
              <label htmlFor="department">
                Department
              </label>
              <input
                name="department"
                id="department"
                value={department}
                onChange={this.handleInputChange}
                type="text"
              />
              <label htmlFor="position">
                Position Title
              </label>
              <input
                name="position"
                id="position"
                value={position}
                onChange={this.handleInputChange}
                type="text"
              />
              <label htmlFor="password1">
                Password
              </label>
              <input
                name="password1"
                id="password1"
                value={password1}
                onChange={this.handleInputChange}
                type="password"
              />
              <label htmlFor="password2">
                Confirm Password
              </label>
              <input
                name="password2"
                id="password2"
                value={password2}
                onChange={this.handleInputChange}
                type="password"
              />
              <div className="fullscreen-form__button-wrapper">
                <button
                  type="submit"
                  className="button button--large"
                  onClick={this.login}
                >
                  Register
                </button>
              </div>
            </form>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { loggedIn: state.users.currentUserId && sessionStorage.jwt };
}

function mapDispatchToProps(dispatch) {
  return { usersActions: bindActionCreators(usersActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(JoinPage);



// WEBPACK FOOTER //
// ./src/components/pages/JoinPage.js